import { ReactNode } from "react";
import {
  StatusColors,
  TCarbonComponentSizeProps,
} from "../../interfaces-and-types";

import { View } from "./View";

export interface IBadgeProps {
  title?: string;
  statusColor: StatusColors;
  indicatorComponent?: ReactNode;
  indicatorColor?: StatusColors;
  hideIndicator?: boolean;
  indicatorSize?: TCarbonComponentSizeProps;
  text?: string | ReactNode;
  largeFont?: boolean;
  className?: string;
  contentContainerClassName?: string;
}

export const Badge = (props: IBadgeProps) => {
  return <View {...props} />;
};
